import { cn } from '../../utils/cn';
import { exhaustiveCheck } from '../../utils/exhaustive-check';

type LogoSize = 'sm' | 'md' | 'lg';

type NameWithLogoProps = {
  name: string;
  logo?: string | null;
  logoAlt?: string;
  logoSize?: LogoSize;
  className?: string;
};

export const NameWithLogo = ({ name, logo, logoAlt, className, logoSize = 'sm' }: NameWithLogoProps) => {
  const logoSizeClass = getLogoSizeClass(logoSize);

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {logo && (
        <div className={cn('overflow-hidden rounded-full', logoSizeClass)}>
          <img
            src={logo}
            alt={logoAlt || ''}
            loading="eager"
            fetchpriority="high"
            className="h-full w-full object-contain"
          />
        </div>
      )}

      <p className="text-nowrap">{name}</p>
    </div>
  );
};

const getLogoSizeClass = (logoSize: LogoSize) => {
  switch (logoSize) {
    case 'sm':
      return 'w-4 h-4';
    case 'md':
      return 'w-5 h-5';
    case 'lg':
      return 'w-6 h-6';
    default:
      return exhaustiveCheck(logoSize);
  }
};
